import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  IEventCategoryData,
  IEventTypeData,
} from '@/src/v2/service/graphql/generated/gql-api.generated';

export type MenuBoard =
  | 'dashboard'
  | 'landing'
  | 'event'
  | 'pricing'
  | 'categories'
  | null;
type ActiveEventOverviewPage =
  | 'streams'
  | 'sponsors'
  | 'members'
  | 'attendees'
  | 'teams'
  | 'brackets'
  | 'leaderboards'
  | 'about'
  | 'event_chats'
  | undefined;

type MultiviewEventPage =
  | 'streams'
  | 'about'
  | 'manage'
  | 'sponsors'
  | 'event_chats'
  | 'bracket'
  | undefined;

type ToastMessage =
  | {
      type: 'error' | 'success' | 'info';
      message: string;
    }
  | undefined;

type PresentationSlice = {
  isSidebarOpen: boolean;
  isSearchOpen: boolean;
  menuBoard: MenuBoard;
  eventTypes: IEventTypeData[];
  eventCategories: IEventCategoryData[];
  withAd: boolean;
  toastMessage: ToastMessage;
  activeEventOverviewPage: ActiveEventOverviewPage;
  isEventSidebarOpen: boolean;
  chatHeight: string;
  activeMultiviewEventPage: MultiviewEventPage;
};

const initialState: PresentationSlice = {
  isSidebarOpen: true,
  isSearchOpen: false,
  menuBoard: null,
  eventTypes: [],
  eventCategories: [],
  withAd: false,
  toastMessage: undefined,
  activeEventOverviewPage: undefined,
  isEventSidebarOpen: true,
  chatHeight: '0',
  activeMultiviewEventPage: undefined,
};

const presentationSlice = createSlice({
  name: 'presentation',
  initialState,
  reducers: {
    setIsSidebarOpen: (
      state: PresentationSlice,
      action: PayloadAction<boolean>
    ) => {
      state.isSidebarOpen = action.payload;
    },
    setIsSearchOpen: (
      state: PresentationSlice,
      action: PayloadAction<boolean>
    ) => {
      state.isSearchOpen = action.payload;
    },
    setChatHeight: (
      state: PresentationSlice,
      action: PayloadAction<string>
    ) => {
      state.chatHeight = action.payload;
    },
    setMenuBoard: (
      state: PresentationSlice,
      action: PayloadAction<MenuBoard>
    ) => {
      state.menuBoard = action.payload;
    },
    setEventCategories: (
      state: PresentationSlice,
      action: PayloadAction<IEventCategoryData[]>
    ) => {
      state.eventCategories = action.payload;
    },
    setEventTypes: (
      state: PresentationSlice,
      action: PayloadAction<IEventTypeData[]>
    ) => {
      state.eventTypes = action.payload;
    },
    setWithAd: (state: PresentationSlice, action: PayloadAction<boolean>) => {
      state.withAd = action.payload;
    },
    setToastMessage: (
      state: PresentationSlice,
      action: PayloadAction<ToastMessage>
    ) => {
      state.toastMessage = action.payload;
    },
    setActiveEventOverviewPage: (
      state: PresentationSlice,
      action: PayloadAction<ActiveEventOverviewPage>
    ) => {
      state.activeEventOverviewPage = action.payload;
    },
    setIsEventSideBarOpen: (
      state: PresentationSlice,
      action: PayloadAction<boolean>
    ) => {
      state.isEventSidebarOpen = action.payload;
    },
    setActiveMultiviewEventPage: (
      state: PresentationSlice,
      action: PayloadAction<MultiviewEventPage>
    ) => {
      state.activeMultiviewEventPage = action.payload;
    },
  },
});

export const {
  setIsSidebarOpen,
  setIsSearchOpen,
  setEventCategories,
  setEventTypes,
  setMenuBoard,
  setWithAd,
  setToastMessage,
  setActiveEventOverviewPage,
  setIsEventSideBarOpen,
  setChatHeight,
  setActiveMultiviewEventPage,
} = presentationSlice.actions;

export default presentationSlice.reducer;
